
var customTags = {
	separator: { label: "Separator", id: '{separator[" - "]}', value: "-" },

	currentYear: {
		label: "Current Year",
		id: '{currentYear["y"]}',
		value: "2023",
	},
	currentMonth: {
		label: "Current Month",
		id: '{currentMonth["m"]}',
		value: "07",
	},
	currentDay: { label: "Current Day", id: '{currentDay["d"]}', value: "01" },

	currentTime: {
		label: "Current Time",
		id: '{currentTime["h: i:sa"]}',
		value: "06:00:00:am",
	},
	postPublishDate: {
		label: "Post Publish Date",
		id: '{postPublishDate["d-m-Y"]}',
		value: "01-01-2023",
	},

	siteTitle: { label: "Site Title", id: "{siteTitle}", value: "WordPress" },
	siteDescription: {
		label: "Site Description",
		id: "{siteDescription}",
		value: "Hello site description",
	},
	postTagsTitle: {
		label: "Post Tags Title",
		id: '{postTagsTitle["3, -"]}',
		value: "football , cricket",
	},
	postCategoriesTitle: {
		label: "Post Categories Title",
		id: '{postCategoriesTitle["3, -"]}',
		value: "football , cricket",
	},
	termDescription: {
		label: "Term Description",
		id: "{termDescription}",
		value: "Hello term description",
	},
	termId: { label: "Term Id", id: "{termId}", value: "123" },
	authorDescription: {
		label: "Author Description",
		id: "{authorDescription}",
		value: "Hello author description",
	},
	authorId: { label: "Author Id", id: "{authorId}", value: "123" },
	postId: { label: "Post ID", id: "{postID}", value: "123" },

	excerpt: { label: "Post Excerpt", id: "{excerpt}", value: "hello excerpt" },
	termTitle: {
		label: "Term Title",
		id: "{termTitle}",
		value: "Hello Term Title",
		isPro: true,
	},
	currentDate: {
		label: "Current Date",
		id: '{currentDate["d- m - Y"]}',
		value: "01-01-2023",
		isPro: true,
	},
	postModifiedDate: {
		label: "Post Modified Date",
		id: '{postModifiedDate["d - m - Y"]}',
		value: "01-01-2023",
		isPro: true,
	},
	termPostCount: {
		label: "Term Post Count",
		id: "{termPostCount}",
		value: "123",
		isPro: true,
	},
	postTagTitle: {
		label: "Post Tag Title",
		id: "{postTagTitle}",
		value: "sports",
		isPro: true,
	},

	postCategoryTitle: {
		label: "Post Category Title",
		id: "{postCategoryTitle}",
		value: "sports",
		isPro: true,
	},

	postTermTitle: {
		label: "Post Term Title",
		id: '{postTermTitle["taxonomy"]}',
		value: "sports",
		isPro: true,
	},
	postTermsTitle: {
		label: "Post Terms Title",
		id: '{postTermsTitle["taxonomy, 3"]}',
		value: "football , cricket",
		isPro: true,
	},
	postSlug: { label: "Post Slug", id: "{postSlug}", value: "post-slug", isPro: true, },
	postStatus: { label: "Post Status", id: "{postStatus}", value: "published", isPro: true, },

	authorName: {
		label: "Author Name",
		id: "{authorName}",
		value: "hello author",
		isPro: true,
	},
	authorFirstName: {
		label: "Author FirstName",
		id: "{authorFirstName}",
		value: "first name",
		isPro: true,
	},
	authorLastName: {
		label: "Author Last Name",
		id: "{authorLastName}",
		value: "last name",
		isPro: true,
	},

	rankmathTitle: {
		label: "Rankmath Title",
		id: "{rankmathTitle}",
		value: "Rank Math Title",
		isPro: true,
	},
	// rankmathPermalink: {
	// 	label: "Rankmath Permalink",
	// 	id: '{rankmathPermalink}',
	// 	value: "",
	// },
	rankmathDescription: {
		label: "Rankmath Description",
		id: "{rankmathDescription}",
		value: "Rank Math Description",
		isPro: true,
	},
	rankmathFocusKeyword: {
		label: "Rankmath Focus Keyword",
		id: "{rankmathFocusKeyword}",
		value: "Rank Math Focus Keyword",
		isPro: true,
	},
	// rankmathFocusKeywords: {
	// 	label: "Rankmath Focus Keywords",
	// 	id: '{rankmathFocusKeywords[", "]}',
	// 	value: "",
	// },
	rankmathOrgname: {
		label: "Rankmath Org name",
		id: "{rankmathOrgname}",
		value: "Rank Math Org Name",
		isPro: true,
	},
	rankmathOrgurl: {
		label: "Rankmath Org URL",
		id: "{rankmathOrgurl}",
		value: "https://hello.world",
		isPro: true,
	},
	rankmathOrglogo: {
		label: "Rankmath Org logo",
		id: "{rankmathOrglogo}",
		value: "",
		isPro: true,
	},

	// siteTagline: { label: "Site Tagline", id: '{siteTagline}', value: "" },
	postMeta: {
		label: "Post Meta",
		id: '{postMeta["metaKey"]}',
		value: "meta value",
		isPro: true,
	},
	searchTerms: {
		label: "Search Terms",
		id: "{searchTerms}",
		value: "hello search terms",
		isPro: true,
	},
	// counter: { label: "Counter", id: '{counter}', value: "" },
};


export default customTags;
